 import Home from './components/Home.vue';
 import Events from './components/Events.vue';
 import Programs from './components/Programs.vue';
 import WhoWeAre from './components/WhoWeAre.vue';
 import Give from './components/Give.vue';
 import Partner from './components/Partner.vue';
 import Fatherhood from './components/Fatherhood.vue';
 import EventPics from './components/EventPics.vue';

 const routes = [
     { path: '/', component: Home },
     { path: '/events', component: Events },
     { path: '/programs', component: Programs },
     { path: '/whoweare', component: WhoWeAre },
     { path: '/give', component: Give },
     { path: '/partners', component: Partner },
     { path: '/fatherhood', component: Fatherhood },
     { path: '/eventpics', component: EventPics },
 ];

 export default routes;
